@file:OptIn(kotlin.uuid.ExperimentalUuidApi::class)

package com.yogaaicoach.pages.workout.test

import com.yogaaicoach.pages.workout.data.WorkoutService
import com.yogaaicoach.platform.continueAudio
import com.yogaaicoach.platform.continueVideo
import com.yogaaicoach.platform.pauseAudio
import com.yogaaicoach.platform.pauseVideo
import kotlinx.coroutines.Job
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.filter
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.launch
import kotlin.uuid.Uuid

internal class TestExerciseJsViewModel(private val workoutService: WorkoutService) {
    private val viewModelScope = MainScope()

    val countdownSeconds = MutableStateFlow(0)
    val isPaused = MutableStateFlow(false)
    val useOtherSideAudio = MutableStateFlow(false)
    val videoUrl = MutableStateFlow<String?>(null)
    val audioUrl = MutableStateFlow<String?>(null)
    val isVideoReady = MutableStateFlow(false)
    val isAudioReady = MutableStateFlow(false)

    private var timerJob: Job? = null
    private var mediaReadyJob: Job? = null

    fun toggleUseOtherSideAudio() {
        useOtherSideAudio.value = !useOtherSideAudio.value
    }

    fun onStartWorkout(exerciseGuidStr: String, durationInSeconds: Int, repetitions: Int, isPortraitView: Boolean) {
        val exerciseGuid = Uuid.parse(exerciseGuidStr)
        timerJob?.cancel()
        mediaReadyJob?.cancel()
        isVideoReady.value = false
        isAudioReady.value = false
        videoUrl.value = null
        audioUrl.value = null
        isPaused.value = false

        viewModelScope.launch {
            val exercise = workoutService.getExercise(exerciseGuid, durationInSeconds, useOtherSideAudio.value) ?: return@launch

            coroutineScope {
                launch {
                    videoUrl.value = workoutService.getExerciseVideoUrls(exercise.video, isPortraitView)?.initialUrl()
                }
                launch {
                    audioUrl.value = workoutService.getAudioUrl(exercise.audio.filename)
                }
            }

            mediaReadyJob = viewModelScope.launch {
                isVideoReady.combine(isAudioReady) { v, a -> v && a }
                    .filter { it }
                    .first()
                continueVideo()
                continueAudio()
                startTimer(durationInSeconds * repetitions)
            }
        }
    }

    fun onVideoReady() { isVideoReady.value = true }
    fun onAudioReady() { isAudioReady.value = true }

    private fun startTimer(totalSeconds: Int) {
        countdownSeconds.value = totalSeconds
        timerJob?.cancel()
        timerJob = viewModelScope.launch {
            while (countdownSeconds.value > 0) {
                delay(1000)
                countdownSeconds.value--
            }
        }
    }

    fun toggleIsPaused() {
        isPaused.value = !isPaused.value
        if (isPaused.value) {
            timerJob?.cancel()
            pauseVideo()
            pauseAudio()
        } else {
            continueVideo()
            continueAudio()
            val remaining = countdownSeconds.value
            if (remaining > 0) startTimer(remaining)
        }
    }
}
